import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive()
export class SvcBtnBaseComponent {
  @Input() color: 'primary' | 'on-primary' | 'text' | 'danger' = 'primary';
  @Input() public processing = false;
  @Input('disabled') public set setDisabled(value: boolean) {
    if (typeof value !== 'boolean') {
      if (typeof value === 'string') {
        value = value === 'true' || value === '';
      } else {
        value = value ?? false;
      }
    }
    this.disabled = value;
  }

  @Output('onClick') click = new EventEmitter<MouseEvent>();

  protected disabled: boolean = false;

  @HostListener('click', ['$event']) protected onClick(event: MouseEvent): void {
    if (this.processing) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    } else {
      !this.disabled && this.click.emit(event);
    }
  }
}
